import React from 'react'
import Watchlist from '../components/MFManagement/Watchlist'

const MFWatchlistManagement = () => {
  return (
    <div className='swift-mf-management swift-content'>
      <Watchlist/>
    </div>
  )
}

export default MFWatchlistManagement
